import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

const deleteModalCardsSlice = createSlice({
  name: "deleteModalCards",
  initialState,
  reducers: {
    openModalDelete: (state, action) => {
      const itemId = action.payload;
      state[itemId] = true;
    },
    closeModalDelete: (state, action) => {
      const itemId = action.payload;
      state[itemId] = false;
    },
  },
});

export const { openModalDelete, closeModalDelete } = deleteModalCardsSlice.actions;
export default deleteModalCardsSlice.reducer;
